import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import AnnouncementBar from './components/AnnouncementBar';
import ScrollProgress from './components/ScrollProgress';
import BrandLoader from './components/BrandLoader';
import CursorTrail from './components/CursorTrail';
import GlobalShipBar from './components/GlobalShipBar';
import SalesPopup from './components/SalesPopup';
import CrownCelebration from './components/CrownCelebration';
import AmbientSound from './components/AmbientSound';
import PageTransition from './components/motion/PageTransition';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

function Layout() {
  const location = useLocation();
  const { pathname } = location;
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      <BrandLoader />
      {!isAdmin && <CursorTrail />}
      {!isAdmin && <ScrollProgress />}
      {!isAdmin && <AnnouncementBar />}
      {!isAdmin && <Header />}
      {!isAdmin && <GlobalShipBar />}
      {!isAdmin && <CartDrawer />}
      {!isAdmin && <SalesPopup />}
      {!isAdmin && <CrownCelebration />}
      {!isAdmin && <AmbientSound />}
      <main>
        <PageTransition routeKey={pathname}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:category" element={<Shop />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </PageTransition>
      </main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    const blockOnImage = (e) => {
      if (e.target && (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO')) e.preventDefault();
    };
    document.addEventListener('contextmenu', blockOnImage);
    document.addEventListener('dragstart', blockOnImage);
    return () => {
      document.removeEventListener('contextmenu', blockOnImage);
      document.removeEventListener('dragstart', blockOnImage);
    };
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
